import createCachedSelector from 're-reselect';

export const selectTopTagEntities = createCachedSelector(
  (state, schema) => state.entities[schema].byId,
  (state, schema) => state.entities.summaries.topTags[schema],
  (tagEntities, topTags) => {
    return topTags.map(topTag => tagEntities[topTag.tag.id]);
  }
)((state, schema) => schema);

export function selectTagSummary(state, tag) {
  return state.entities.summaries[tag.schema][tag.id] || {};
}



// WEBPACK FOOTER //
// ./src/selectors/summarySelectors.js